module.exports = __webpack_public_path__ + "static/Ecuador-9af780c148818d3da5665483bf629355.png";